import {Component, inject, Input} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {CommonValidators} from '@store/common/common.validators';
import {PatronActions} from '@store/patron/patron.actions';
import {BranchSelectors, PatronSelectors} from '@store/store.selectors';
import {passwordConfirmValidator} from '@raven';
import {MatDialog} from '@angular/material/dialog';
import {snapshot} from '@store/store.helpers';
import {LibraryPolicyComponent} from '../library-policy.component';

@Component({
  selector: 'rn-registration-create-password-form',
  templateUrl: './registration-create-password-form.component.html',
  styleUrl: './registration-create-password-form.component.scss',
  standalone: false
})
export class RegistrationCreatePasswordFormComponent {
  @Input() forLookupContext = false;

  @Input() set branchId(branchId: string) {
    this.branchIdField.patchValue(branchId);
  }

  public readonly patronSelectors = PatronSelectors.Registration;
  public readonly branchSelectors = BranchSelectors.List;
  private readonly store = inject(Store);
  private readonly dialog = inject(MatDialog);
  public readonly createPasswordForm = inject(FormBuilder).group({
      password: ['', {validators: [Validators.required, ...CommonValidators.passwordValidators]}],
      confirmPassword: ['', {validators: [Validators.required]}],
      // both required and requiredIdSelect to get the asterisk on the select field while covering 0 id case
      branchId: [snapshot(this.patronSelectors.branchId), [Validators.required, CommonValidators.requiredIdSelect]],
      acceptTerms: []
    },
    {
      validators: passwordConfirmValidator(
        'password',
        'confirmPassword'
      ),
    });
  public readonly branchIdField = this.createPasswordForm.get('branchId') as FormControl;
  public readonly acceptTermsField = this.createPasswordForm.get('acceptTerms') as FormControl;


  public onClickNext() {
    this.store.dispatch(PatronActions.updateRegistration(this.createPasswordForm.value));
    this.store.dispatch(this.forLookupContext ? PatronActions.registerExisting() : PatronActions.register());
  }

  viewLibraryPolicy(event: MouseEvent): void {
    event.preventDefault();
    this.dialog.open(LibraryPolicyComponent);
  }
}
